import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const LoadingSpinner = ({ loaderMessage = 'Loading...' }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                backgroundColor: theme.palette.background.default,
                fontFamily: 'Arial, sans-serif',
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '80px',
                    height: '80px',
                }}
            >
                {/* Outer ring */}
                <Box
                    sx={{
                        position: 'absolute',
                        width: '80px',
                        height: '80px',
                        border: '4px solid #e3f2fd',
                        borderRadius: '50%',
                        opacity: 0.3,
                    }}
                />
                {/* Animated spinner */}
                <Box
                    sx={{
                        position: 'absolute',
                        width: '80px',
                        height: '80px',
                        border: '4px solid transparent',
                        borderTop: '4px solid #2196f3',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                    }}
                />
                {/* Inner accent ring */}
                <Box
                    sx={{
                        position: 'absolute',
                        width: '60px',
                        height: '60px',
                        top: '10px',
                        left: '10px',
                        border: '3px solid transparent',
                        borderTop: '3px solid #64b5f6',
                        borderRadius: '50%',
                        animation: 'spinReverse 0.8s linear infinite',
                    }}
                />
            </Box>

            <Typography
                variant="subtitle1"
                sx={{
                    color: theme.palette.text.primary,
                    fontSize: '18px',
                    fontWeight: 400,
                    marginTop: '16px',
                    letterSpacing: '0.5px',
                }}
            >
                {loaderMessage}
            </Typography>

            <style>
                {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @keyframes spinReverse {
            0% { transform: rotate(360deg); }
            100% { transform: rotate(0deg); }
          }
        `}
            </style>
        </Box>
    );
};

export default LoadingSpinner;